import './style.css';
import { authHeaders, getUser, initAuthUI, startTokenRefresh } from './auth';

const ADMIN_DISCORD_ID = '859970300048572446';

interface Update {
  id: string;
  title: string;
  body: string;
  type: string;
  createdAt: string;
}

document.addEventListener('DOMContentLoaded', () => {
  initAuthUI();
  startTokenRefresh();

  const user = getUser();
  const isAdmin = user && (user.id === ADMIN_DISCORD_ID || `google_${user.id}` === ADMIN_DISCORD_ID);

  // Show admin panel if admin
  const adminPanel = document.getElementById('updatesAdmin');
  if (isAdmin && adminPanel) {
    adminPanel.style.display = 'block';
  }

  // Load updates
  loadUpdates();

  // Admin form submission
  const form = document.getElementById('postUpdateForm') as HTMLFormElement;
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const title = (document.getElementById('updateTitle') as HTMLInputElement).value.trim();
      const body = (document.getElementById('updateBody') as HTMLTextAreaElement).value.trim();
      const type = (document.getElementById('updateType') as HTMLSelectElement).value;

      if (!title || !body) return;

      try {
        const res = await fetch('/api/updates', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...authHeaders() },
          body: JSON.stringify({ title, body, type }),
        });

        if (res.ok) {
          form.reset();
          loadUpdates();
        } else {
          const data = await res.json();
          alert(data.error || 'Failed to post update');
        }
      } catch {
        alert('Failed to post update');
      }
    });
  }

  // Mobile menu toggle
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const navCenter = document.querySelector<HTMLDivElement>('.nav-center');
  if (mobileMenuBtn && navCenter) {
    mobileMenuBtn.addEventListener('click', () => {
      navCenter.classList.toggle('active');
      mobileMenuBtn.classList.toggle('active');
    });
  }
});

async function loadUpdates() {
  const feed = document.getElementById('updatesFeed');
  if (!feed) return;

  try {
    const res = await fetch('/api/updates');
    if (!res.ok) throw new Error('Failed to load');
    const updates: Update[] = await res.json();

    if (updates.length === 0) {
      feed.innerHTML = '<div class="updates-empty"><p>No updates yet. Check back soon!</p></div>';
      return;
    }

    const user = getUser();
    const isAdmin = user && (user.id === ADMIN_DISCORD_ID || `google_${user.id}` === ADMIN_DISCORD_ID);

    feed.innerHTML = updates.map(update => `
      <article class="update-card">
        <div class="update-header">
          <span class="update-type update-type-${update.type}">${formatType(update.type)}</span>
          <time class="update-date">${formatDate(update.createdAt)}</time>
        </div>
        <h2 class="update-title">${escapeHtml(update.title)}</h2>
        <p class="update-body">${escapeHtml(update.body)}</p>
        ${isAdmin ? `<button class="update-delete-btn" data-id="${update.id}">Delete</button>` : ''}
      </article>
    `).join('');

    // Attach delete handlers for admin
    if (isAdmin) {
      feed.querySelectorAll('.update-delete-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
          const id = (btn as HTMLElement).dataset.id;
          if (!confirm('Delete this update?')) return;
          try {
            const res = await fetch(`/api/updates/${id}`, {
              method: 'DELETE',
              headers: authHeaders(),
            });
            if (res.ok) loadUpdates();
          } catch { /* ignore */ }
        });
      });
    }
  } catch {
    feed.innerHTML = '<div class="updates-empty"><p>Failed to load updates.</p></div>';
  }
}

function formatType(type: string): string {
  const map: Record<string, string> = {
    announcement: 'Announcement',
    'new-feature': 'New Feature',
    deal: 'New Deal',
    fix: 'Bug Fix',
  };
  return map[type] || type;
}

function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function escapeHtml(str: string): string {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}
